import Sales from "./components/Sales";

export default Sales;
